import { defineMessages } from 'react-intl';

export default function initValidations() {
  defineMessages({
    validation_error_404: {
      id: 'validation.error.key.404',
      defaultMessage: 'Not found',
    },
    validation_error_409: {
      id: 'validation.error.key.409',
      defaultMessage: 'Duplicate',
    },
    validation_error_form: {
      id: 'validation.error.key.form',
      defaultMessage: 'Form',
    },
  });

  defineMessages({
    validation_error_required: {
      id: 'validation.error.required',
      defaultMessage: 'This field is required.',
    },
    validation_error_number: {
      id: 'validation.error.number',
      defaultMessage: 'Please enter a number.',
    },
    validation_error_url: {
      id: 'validation.error.url',
      defaultMessage: 'Please enter a valid URL.',
    },
    validation_error_max_length: {
      id: 'validation.error.max_length',
      defaultMessage: 'This field exceeds the character limit.',
    },
    validation_error_duplicate: {
      id: 'validation.error.duplicate',
      defaultMessage: 'The record is ambiguous.',
    },
    validation_error_ref_not_found: {
      id: 'validation.error.ref_not_found',
      defaultMessage: 'Reference not found.',
    },
  });
}
